/* eslint-disable @typescript-eslint/no-explicit-any */
import * as L from 'leaflet';
import * as turf from '@turf/turf';

export default async function initInteractiveMap(): Promise<void> {
    const $interactiveMapContainer = document.querySelectorAll<HTMLElement>('.block-chiffres-cles-carte-interactive');
    
    $interactiveMapContainer.forEach(async ($container) => {
        new InteractiveMap($container);
    });
}

class InteractiveMap {
    $el: HTMLElement | null | undefined;
    mobileBreakpoint: number;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.mobileBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-main-header')) + 1;
        this.initMap('regions');
        // TODO
        // Responsive
        //this.sortMobileFedeList();
    }

    async initMap(container: string): Promise<void> {
        
        const mapContainer = this.$el?.querySelector(`#interactive-map-${container}`) as HTMLElement;
        
        const datasMap = JSON.parse((window as any).datas_map_regions);
        
        const fond_carte = await fetchData(datasMap.fond_carte);
        const adherents = await fetchData(datasMap.adherents);
        
        // ajustement du zoom
        const map = L.map(mapContainer, {
            zoomSnap: 0.4,
            scrollWheelZoom: false
        });

        map.setView([46.227638, 2.213749], 5.40);
        // on enleve le drag
        map.dragging.disable();
        
        const getColor = () => {
            return '#C5ECB6';
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const style = () => {
            return {
                fillColor: getColor(),
                weight: .5,
                opacity: 1,
                color: '#FFF',
                fillOpacity: 1,
            };
        }

        let geojson = L.geoJson(fond_carte);
        
        
        const highlightFeature = (e: any) => {
            const layer = e.target;
            const center = turf.center(layer.feature).geometry.coordinates;
            
            const name = adherents[layer.feature.properties.code]?.nom || '';
            const adherents_count = adherents[layer.feature.properties.code]?.adherents || '';

            let offset = [0, 20];

            // Traitement spécifique sur la Corse qui est au bord de la carte
            if ('Corse' === name) {
                offset = [-30, 20];
            }

            if (adherents_count) {
                const tooltip = L.tooltip({
                    permanent: false,
                    direction: 'bottom',
                    className: 'region-tooltip',
                    offset: offset,
                    opacity: 1,
                    pane: 'tooltipPane',
                })
                    .setLatLng([center[1], center[0]])
                    .setContent(`
                    <div class="title">${name}</div>
                    <div class="adherents">${adherents_count} adhérents</div>
                `)
                    .addTo(map);
                    
                layer.tooltip = tooltip;
            }
        
            layer.setStyle({
                weight: 1,
                fillColor: '#FFFFFF',
            });
        
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                layer.bringToFront();
            }
        }

        const resetHighlight = (e: any) => {
            const layer = e.target;
            geojson.resetStyle(layer);

            if (layer.tooltip) {
                map.removeLayer(layer.tooltip);
                delete layer.tooltip;
            }
        }

        const gotoUrl = (e: any) => {
            const layer = e.target;
            const url = adherents[layer.feature.properties.code]?.url || '';
            if (url) {
                location.href = url;
            }
        }
       
        function onEachFeature(feature: any, layer: any) {
            const center = turf.center(feature).geometry.coordinates;
            const adherents_count = adherents[feature.properties.code].adherents;

            if (adherents_count) {
                L.circle([center[1], center[0]], {
                    radius: 10000,
                }).addTo(map);
                
                L.marker([center[1], center[0]], {
                    icon: L.divIcon({
                        className: 'circle-label',
                        html: `<div>${adherents_count}</div>`,
                        iconSize: [29, 29]
                    })
                }).addTo(map);

                layer.on({
                    mouseover: highlightFeature,
                    mouseout: resetHighlight,
                    click: gotoUrl,
                });
            }
        }

        geojson = L.geoJson(fond_carte, {
            style: style,
            onEachFeature: onEachFeature
        }).addTo(map);
    }

    sortMobileFedeList() {
        function comparator(a: any, b: any) {
            if (a.dataset.zip < b.dataset.zip)
                return -1;
            if (a.dataset.zip > b.dataset.zip)
                return 1;
            return 0;
        }

        const choices = this.$el?.querySelectorAll('[data-zip]');
        const content = this.$el?.querySelector('.dropdown-content') as any;

        if (choices && content) {
            const subjectsArray = Array.from(choices);
            const sorted = subjectsArray.sort(comparator);

            sorted.forEach(el => content.appendChild(el))
        }
    }
}

async function fetchData(fileURL: string): Promise<any> {
    const response = await fetch(fileURL);
    const json = await response.json();

    return json;
}